<ng-container *ngIf="orderId">
    <ng-container *ngIf="disableLink || !viewData; else withLink">
        <span [attr.data-test]="dataTest">{{ viewData }}</span>
    </ng-container>
    <ng-template #withLink>
        <a (mousedown)="prepareNewTab($event)"
           (click)="click($event)"
           [attr.data-test]="dataTest"
           [attr.target]="openInNewTab ? '_blank' : null"
           [attr.rel]="openInNewTab ? 'noopener' : null"
           [bcmRouterLink]="['orders', orderId]">
            {{ viewData }}
        </a>
    </ng-template>
</ng-container>
